// extracted by mini-css-extract-plugin
module.exports = {"dialog":"AddBankPopup_dialog_2PP5A","real_name":"AddBankPopup_real_name_1zibN","certify":"AddBankPopup_certify_2JSUU","actions":"AddBankPopup_actions_1u0Fc"};